import { createCommentVNode as _createCommentVNode, resolveComponent as _resolveComponent, openBlock as _openBlock, createBlock as _createBlock, renderSlot as _renderSlot, createElementVNode as _createElementVNode, normalizeClass as _normalizeClass, withCtx as _withCtx, createVNode as _createVNode, createElementBlock as _createElementBlock, normalizeStyle as _normalizeStyle, toDisplayString as _toDisplayString, createTextVNode as _createTextVNode, withKeys as _withKeys } from "vue";
const _hoisted_1 = { class: "header-title-text d-flex align-center" };
const _hoisted_2 = {
    key: 0,
    class: "dialog__horizontal-header"
};
const _hoisted_3 = { class: "dialog__left-part" };
const _hoisted_4 = { class: "d-flex align-center" };
const _hoisted_5 = { class: "contents-title-text ml-1" };
const _hoisted_6 = { class: "body2-text d-flex align-center" };
const _hoisted_7 = {
    key: 1,
    class: "dialog__right-part"
};
const _hoisted_8 = { class: "d-flex align-center" };
const _hoisted_9 = { class: "contents-title-text ml-1" };
const _hoisted_10 = { class: "body2-text d-flex align-center" };
export function render(_ctx, _cache, $props, $setup, $data, $options) {
    const _component_v_btn = _resolveComponent("v-btn");
    const _component_v_card_title = _resolveComponent("v-card-title");
    const _component_v_divider = _resolveComponent("v-divider");
    const _component_v_card_text = _resolveComponent("v-card-text");
    const _component_v_card_actions = _resolveComponent("v-card-actions");
    const _component_v_card = _resolveComponent("v-card");
    const _component_v_dialog = _resolveComponent("v-dialog");
    return (_openBlock(), _createBlock(_component_v_dialog, {
        "no-click-animation": _ctx.noClickAnimation,
        scrim: _ctx.scrim,
        persistent: _ctx.persistent,
        "model-value": _ctx.isDialogOpen,
        "content-class": _ctx.computedDialogCssClass,
        width: _ctx.width ? _ctx.width : undefined,
        "min-width": _ctx.width ? _ctx.width : undefined,
        "max-width": _ctx.width ? _ctx.width : undefined,
        "onUpdate:modelValue": _ctx.onCancel,
        onKeydown: _withKeys(_ctx.onCancel, ["esc"])
    }, {
        default: _withCtx(() => [
            _createVNode(_component_v_card, {
                class: _normalizeClass(["card", _ctx.resize ? 'resize' : ''])
            }, {
                default: _withCtx(() => [
                    _createCommentVNode(" 우상단 닫기 버튼 "),
                    (!_ctx.isHideCloseBtn)
                        ? (_openBlock(), _createBlock(_component_v_btn, {
                            key: 0,
                            icon: "mdi-close",
                            variant: "text",
                            class: "btn-close",
                            onClick: _ctx.onCancel
                        }, null, 8 /* PROPS */, ["onClick"]))
                        : _createCommentVNode("v-if", true),
                    _createCommentVNode(" Header "),
                    _createVNode(_component_v_card_title, {
                        class: _normalizeClass(["dialog__head d-flex", _ctx.draggable ? 'vss-movable' : ''])
                    }, {
                        default: _withCtx(() => [
                            _createElementVNode("span", _hoisted_1, [
                                _createCommentVNode(" title "),
                                _renderSlot(_ctx.$slots, "title", {}, undefined, true),
                                _createCommentVNode(" appendTitle "),
                                _renderSlot(_ctx.$slots, "appendTitle", {}, undefined, true)
                            ])
                        ]),
                        _: 3 /* FORWARDED */
                    }, 8 /* PROPS */, ["class"]),
                    _createVNode(_component_v_divider),
                    _createCommentVNode(" Body "),
                    _createVNode(_component_v_card_text, {
                        class: "dialog__body",
                        style: _normalizeStyle(_ctx.computedHeight)
                    }, {
                        default: _withCtx(() => [
                            _createCommentVNode(" 수평스타일 헤더 "),
                            (_ctx.hasHorizontalHeader)
                                ? (_openBlock(), _createElementBlock("div", _hoisted_2, [
                                    _renderSlot(_ctx.$slots, "horizontalHeader", {}, undefined, true)
                                ]))
                                : _createCommentVNode("v-if", true),
                            _createCommentVNode(" 추가 컨텐츠 "),
                            _renderSlot(_ctx.$slots, "preContent", {}, undefined, true),
                            _createCommentVNode(" 좌측 구역 "),
                            _createElementVNode("div", _hoisted_3, [
                                (_ctx.hasLeftTitle)
                                    ? (_openBlock(), _createBlock(_component_v_card_title, {
                                        key: 0,
                                        class: "contents-title-text dialog__sub-title"
                                    }, {
                                        default: _withCtx(() => [
                                            _createElementVNode("span", _hoisted_4, [
                                                _createCommentVNode(" leftSubTitle "),
                                                _renderSlot(_ctx.$slots, "leftSubTitle", {}, undefined, true),
                                                _createElementVNode("span", _hoisted_5, [
                                                    _createCommentVNode(" appendLeftSubTitle "),
                                                    _renderSlot(_ctx.$slots, "appendLeftSubTitle", {}, undefined, true)
                                                ])
                                            ]),
                                            _createElementVNode("span", _hoisted_6, [
                                                _createCommentVNode(" leftSubInfo "),
                                                _renderSlot(_ctx.$slots, "leftSubInfo", {}, undefined, true)
                                            ])
                                        ]),
                                        _: 3 /* FORWARDED */
                                    }))
                                    : _createCommentVNode("v-if", true),
                                (_ctx.hasLeftTitle)
                                    ? (_openBlock(), _createBlock(_component_v_divider, { key: 1 }))
                                    : _createCommentVNode("v-if", true),
                                _createVNode(_component_v_card_text, { class: "part-content-wrapper" }, {
                                    default: _withCtx(() => [
                                        _createElementVNode("div", {
                                            class: _normalizeClass(`
                  ${_ctx.isEmptyBox ? 'empty-box' : 'content-box'}
                  ${_ctx.isContentBoxPadding ? 'padding' : ''}
                `)
                                        }, [
                                            _createCommentVNode(" leftContent "),
                                            _renderSlot(_ctx.$slots, "leftContent", {}, undefined, true)
                                        ], 2 /* CLASS */)
                                    ]),
                                    _: 3 /* FORWARDED */
                                })
                            ]),
                            _createCommentVNode(" 우측 구역 "),
                            (_ctx.isDivided)
                                ? (_openBlock(), _createElementBlock("div", _hoisted_7, [
                                    (_ctx.hasRightTitle)
                                        ? (_openBlock(), _createBlock(_component_v_card_title, {
                                            key: 0,
                                            class: "contents-title-text dialog__sub-title"
                                        }, {
                                            default: _withCtx(() => [
                                                _createElementVNode("span", _hoisted_8, [
                                                    _createCommentVNode(" rightSubTitle "),
                                                    _renderSlot(_ctx.$slots, "rightSubTitle", {}, undefined, true),
                                                    _createElementVNode("span", _hoisted_9, [
                                                        _createCommentVNode(" appendRightSubTitle "),
                                                        _renderSlot(_ctx.$slots, "appendRightSubTitle", {}, undefined, true)
                                                    ])
                                                ]),
                                                _createElementVNode("span", _hoisted_10, [
                                                    _createCommentVNode(" rightSubInfo "),
                                                    _renderSlot(_ctx.$slots, "rightSubInfo", {}, undefined, true)
                                                ])
                                            ]),
                                            _: 3 /* FORWARDED */
                                        }))
                                        : _createCommentVNode("v-if", true),
                                    (_ctx.hasRightTitle)
                                        ? (_openBlock(), _createBlock(_component_v_divider, { key: 1 }))
                                        : _createCommentVNode("v-if", true),
                                    _createVNode(_component_v_card_text, { class: "part-content-wrapper" }, {
                                        default: _withCtx(() => [
                                            _createElementVNode("div", {
                                                class: _normalizeClass(`
                  ${_ctx.isEmptyBox ? 'empty-box' : 'content-box'}
                  ${_ctx.isContentBoxPadding ? 'padding' : ''}
                `)
                                            }, [
                                                _createCommentVNode(" rightContent "),
                                                _renderSlot(_ctx.$slots, "rightContent", {}, undefined, true)
                                            ], 2 /* CLASS */)
                                        ]),
                                        _: 3 /* FORWARDED */
                                    })
                                ]))
                                : _createCommentVNode("v-if", true)
                        ]),
                        _: 3 /* FORWARDED */
                    }, 8 /* PROPS */, ["style"]),
                    _createVNode(_component_v_divider),
                    _createCommentVNode(" Footer "),
                    (_ctx.hasFooter)
                        ? (_openBlock(), _createBlock(_component_v_card_actions, {
                            key: 1,
                            class: "pa-4 d-flex justify-end dialog__footer"
                        }, {
                            default: _withCtx(() => [
                                _renderSlot(_ctx.$slots, "buttonSet", {}, () => [
                                    _createVNode(_component_v_btn, {
                                        class: "btn-outlined-basic brg-btn width-xs size-l",
                                        color: "black",
                                        large: "",
                                        variant: "outlined",
                                        onClick: _ctx.onCancel
                                    }, {
                                        default: _withCtx(() => [
                                            _createTextVNode(_toDisplayString(_ctx.$t('common.cancel')), 1 /* TEXT */)
                                        ]),
                                        _: 1 /* STABLE */
                                    }, 8 /* PROPS */, ["onClick"]),
                                    _createVNode(_component_v_btn, {
                                        class: "btn-apply brg-btn width-xs size-l",
                                        large: "",
                                        variant: "outlined",
                                        disabled: _ctx.isApplyDisabled,
                                        onClick: _ctx.onApply
                                    }, {
                                        default: _withCtx(() => [
                                            _createTextVNode(_toDisplayString(_ctx.$t('common.apply')), 1 /* TEXT */)
                                        ]),
                                        _: 1 /* STABLE */
                                    }, 8 /* PROPS */, ["disabled", "onClick"])
                                ], true)
                            ]),
                            _: 3 /* FORWARDED */
                        }))
                        : _createCommentVNode("v-if", true)
                ]),
                _: 3 /* FORWARDED */
            }, 8 /* PROPS */, ["class"])
        ]),
        _: 3 /* FORWARDED */
    }, 8 /* PROPS */, ["no-click-animation", "scrim", "persistent", "model-value", "content-class", "width", "min-width", "max-width", "onUpdate:modelValue", "onKeydown"]));
}
